import { Component, OnInit } from '@angular/core';
import {VersaoHttpService} from "../../services/persist/http/VersaoHttpService";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {SQLiteService} from "../../services/sqlite.service";
import {Versao} from "../../domain/Versao";
import {Sincronizador} from "../../services/sincronizacao/Sincronizador";
import {Baixavel} from "./Baixavel";
import {lastValueFrom} from "rxjs";
import {Browser} from "@capacitor/browser";
import {AuthService} from "@auth0/auth0-angular";
import {Enviavel} from "./Enviavel";

@Component({
  selector: 'app-sincronizacao',
  templateUrl: './sincronizacao.component.html',
  styleUrls: ['./sincronizacao.component.scss'],
})
export class SincronizacaoComponent  implements OnInit {

  protected baixaveis: Baixavel[]=[]
  protected enviaveis: Enviavel[]=[]
  type="indeterminate"
  progress = 0
  texto = "Verificando atualizações..."
  working = true


  constructor(private sinc: Sincronizador, private httpVersao: VersaoHttpService, private auth: AuthService) {
  }

  ngOnInit() {
    this.refresh().then(r => this.type="determinate")
  }

  async refresh(){
    try {
      this.working = true
      const versao = await lastValueFrom(this.httpVersao.getVersao())
      this.baixaveis = []
      this.enviaveis = []
      for (const i of this.sinc.receber) {
        if (await i.checkSincronizacao(versao)) {
          this.baixaveis.push(new Baixavel(i))
        }
      }
      for(const i of this.sinc.enviar){
        const enviaveis = await i.getPendencias()
        if(enviaveis.length > 0 )
          this.enviaveis.push(new Enviavel(i,  enviaveis.length))
      }
      this.texto = this.baixaveis.length + this.enviaveis.length == 0 ? "Nada a fazer": ""

    }catch (e) {
      if(e instanceof HttpErrorResponse && e.status == 401)
        this.auth
          .loginWithRedirect({
            async openUrl(url: string) {
              return Browser.open({ url, windowName: '_self' });
            }
          })
          .subscribe();
      console.error('erro',e)
      this.texto = "Erro ao buscar atualizações: " + e.statusText
    } finally {
      this.working = false
    }

  }

  async exibe(v: Versao[]){
    this.baixaveis = []
    for (const i of this.sinc.receber) {
      if(await i.checkSincronizacao(v)){
        this.baixaveis.push(new Baixavel(i))
      }
    }
  }

  async baixar(incr: number) {
    for (const b of this.baixaveis) {
      b.sincronizando = true
      try {
        const resp = await b.download.sinc()
        if(resp && resp > 0){
          b.texto = resp+''
          b.ok  = true
        }
      } catch (e) {
        b.texto = e.message
        b.ok = false
      } finally {
        b.sincronizando = false
        this.progress += incr
      }
    }
  }

  async sincronizar(){
    this.working=true
    try {
      console.log('iniciando upload')
      this.progress = 0
      const incr = 1 / (this.enviaveis.length + this.baixaveis.length)
      await this.enviar(incr)
      this.working=true
      await this.refresh()
      this.working=true
      await this.baixar(incr)
    } finally {
      this.working = false
    }

  }

  async enviar(incr: number) {
    for (const b of this.enviaveis) {
      b.sincronizando = true
      try {
        await b.upload.sendRecords()
        b.texto = ''
        b.ok  = true
      } catch (e) {
        b.texto = e.message
        b.ok = false
      } finally {
        this.progress += incr
        b.sincronizando = false
      }
    }
  }
}
